import type { LedgerYear } from '../types'

import { defineStore } from 'pinia'

import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

export const usePeriodPicker = defineStore('periodPicker', {
  state: (): {
    currentLedgerId: number
    ledgersPerYear: number
    isLoading: boolean
    years: LedgerYear[]
  } => ({
    currentLedgerId: -1,
    ledgersPerYear: 0,
    isLoading: false,
    years: [],
  }),
  actions: {
    async requestData(url: string) {
      try {
        this.isLoading = true

        const data = (await SFetch.json(url, {
          method: 'GET',
        })) as {
          currentLedgerId: number
          ledgersPerYear: number
          years: LedgerYear[]
        }

        this.currentLedgerId = data.currentLedgerId
        this.ledgersPerYear = data.ledgersPerYear
        this.years = data.years
      } catch (err) {
        SfLog.warn('Error fetching period picker data', {
          extra: {
            error: err,
          },
        })
      } finally {
        this.isLoading = false
      }
    },
  },
  getters: {
    hasRequiredData(state): boolean {
      return (
        !state.isLoading &&
        state.currentLedgerId !== -1 &&
        state.years.length > 0
      )
    },
  },
})
